import translateExchangeIds from '../services/translateExchangeIds';
import { convertEwsIdToRestId } from 'owa-identifiers';

/**
 * Translates the given EWS immutable itemIds to the corresponding EWS Item.
 * @param immutableIds itemIds to translate
 * @return array of TranslateExchangeIdsResponseItem
 */
export default function translateEwsImmutableIdsToEwsIds(immutableIds: string[], headers?: any) {
    const restImmutableIds: string[] = [];
    immutableIds.forEach(id => {
        const restImmutableId = convertEwsIdToRestId(id);
        if (restImmutableId) {
            restImmutableIds.push(restImmutableId);
        }
    });
    return translateExchangeIds('restImmutableEntryId', 'ewsId', restImmutableIds, headers);
}
